import { render, staticRenderFns } from "./OrderDetailRow.vue?vue&type=template&id=3569b58a"
import script from "./OrderDetailRow.vue?vue&type=script&lang=js"
export * from "./OrderDetailRow.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailRow.vue?vue&type=style&index=0&id=3569b58a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports